import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './components/Toast';
import { AuthProvider } from './contexts/AuthContext';
import { InstancesProvider } from './contexts/InstancesContext';
import { CadastroProvider } from './contexts/CadastroContext';

import Login from './pages/Login';
import Register from './pages/Register';
import ContaSuspensa from './pages/ContaSuspensa';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import AppConfig from './pages/AppConfig';
import SelectAccount from './pages/SelectAccount';
import InstancesManagement from './pages/InstancesManagement';
import Contacts from './pages/Contacts';
import Groups from './pages/Groups';
import GroupDetails from './pages/GroupDetails';
import WhatsappGroups from './pages/WhatsappGroups';
import WhatsappGroupDetail from './pages/WhatsappGroupDetail';
import Campaigns from './pages/Campaigns';
import Pedidos from './pages/Pedidos';
import ProdutosCatalogo from './pages/ProdutosCatalogo';
import CampaignDetails from './pages/CampaignDetails';
import CampaignForm from './pages/CampaignForm';
import Templates from './pages/Templates';
import Personas from './pages/Personas';
import Messages from './pages/Messages';
import Users from './pages/Users';
import AdminPanel from './pages/AdminPanel';

// Admin Pages
import AdminUsers from './pages/admin/Users';
import AdminClients from './pages/admin/Clients';
import AdminManagement from './pages/admin/Management';
import AdminPlans from './pages/admin/Plans';
import AdminVendedores from './pages/admin/Vendedores';
import AdminVendedorDetalhe from './pages/admin/VendedorDetalhe';
import AdminLeads from './pages/admin/Leads';
import AdminLeadsContato from './pages/admin/LeadsContato';
import AdminZApiInstances from './pages/admin/ZApiInstances';
import AdminCobranca from './pages/admin/Cobranca';
import AdminWallet from './pages/admin/Wallet';
import ClientDetails from './pages/admin/ClientDetails';
import GlobalConfirmModal from './components/GlobalConfirmModal';

import Sessions from './pages/Sessions';
import Atendimento from './pages/Atendimento';
import Planos from './pages/Planos';
import Analytics from './pages/Analytics';
import InstagramPosts from './pages/InstagramPosts';
import HashtagMonitoring from './pages/HashtagMonitoring';
import CompetitiveIntelligence from './pages/CompetitiveIntelligence';
import IdeaGenerator from './pages/IdeaGenerator';
import RoteiroEditor from './pages/IdeaGenerator/RoteiroEditor';
import ProtectedRoute from './components/ProtectedRoute';
import ProtectedByLevel from './components/ProtectedByLevel';
import Cobertura from './pages/Cobertura';
import CoberturaSegmento from './pages/CoberturaSegmento';
import Metas from './pages/Metas';
import NotFound from './pages/NotFound';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <InstancesProvider>
          <CadastroProvider>
          <ToastProvider>
          <Router>
          <div className="App">
          <GlobalConfirmModal />
          <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/conta-suspensa" element={<ContaSuspensa />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/conversas" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <Atendimento />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/campanhas" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <Campaigns />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/campanhas/nova" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <CampaignForm />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/campanhas/editar/:id" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <CampaignForm />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/campanhas/:id" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <CampaignDetails />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/templates" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <Templates />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/personas" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <Personas />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/marketing/publicacoes" element={
            <ProtectedRoute>
              <InstagramPosts />
            </ProtectedRoute>
          } />
          <Route path="/insights/publicacoes" element={
            <ProtectedRoute>
              <InstagramPosts />
            </ProtectedRoute>
          } />
          <Route path="/insights/hashtags" element={
            <ProtectedRoute>
              <HashtagMonitoring />
            </ProtectedRoute>
          } />
          <Route path="/insights/inteligencia" element={
            <ProtectedRoute>
              <CompetitiveIntelligence />
            </ProtectedRoute>
          } />
          <Route path="/insights/ideias" element={
            <ProtectedRoute>
              <IdeaGenerator />
            </ProtectedRoute>
          } />
          <Route path="/insights/ideias/roteiro/:id" element={
            <ProtectedRoute>
              <RoteiroEditor />
            </ProtectedRoute>
          } />
          <Route path="/contatos" element={
            <ProtectedRoute>
              <Contacts />
            </ProtectedRoute>
          } />
          <Route path="/segmentos" element={
            <ProtectedRoute>
              <Groups />
            </ProtectedRoute>
          } />
          <Route path="/segmentos/:id" element={
            <ProtectedRoute>
              <GroupDetails />
            </ProtectedRoute>
          } />
          <Route path="/grupos-wa" element={
            <ProtectedRoute>
              <WhatsappGroups />
            </ProtectedRoute>
          } />
          <Route path="/grupos-wa/:id" element={
            <ProtectedRoute>
              <WhatsappGroupDetail />
            </ProtectedRoute>
          } />
          <Route path="/insights/analytics" element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          } />
          <Route path="/analytics/mensagens" element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          } />
          <Route path="/analytics/redes-sociais" element={
            <ProtectedRoute>
              <Analytics />
            </ProtectedRoute>
          } />
          <Route path="/atendimento/agente-ia" element={
            <ProtectedRoute>
              <AppConfig />
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/canais" element={
            <ProtectedRoute>
              <InstancesManagement />
            </ProtectedRoute>
          } />
          <Route path="/select-account" element={
            <ProtectedRoute>
              <SelectAccount />
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/automacao" element={
            <ProtectedRoute>
              <AppConfig />
            </ProtectedRoute>
          } />
          <Route path="/financeiro" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente']}>
                <Planos />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/planos" element={
            <ProtectedRoute>
              <Planos />
            </ProtectedRoute>
          } />
          <Route path="/configuracoes/usuarios" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente']}>
                <Users />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          {/* Rotas legadas (redirect) */}
          <Route path="/atendimento" element={<ProtectedRoute><Atendimento /></ProtectedRoute>} />
          <Route path="/config" element={<ProtectedRoute><AppConfig /></ProtectedRoute>} />
          <Route path="/instances" element={<ProtectedRoute><InstancesManagement /></ProtectedRoute>} />
          <Route path="/contacts" element={<ProtectedRoute><Contacts /></ProtectedRoute>} />
          <Route path="/groups" element={<ProtectedRoute><Groups /></ProtectedRoute>} />
          <Route path="/groups/:id" element={<ProtectedRoute><GroupDetails /></ProtectedRoute>} />
          <Route path="/campaigns" element={<ProtectedRoute><Campaigns /></ProtectedRoute>} />
          <Route path="/pedidos" element={<ProtectedRoute><Pedidos /></ProtectedRoute>} />
          <Route path="/configuracoes/produtos" element={<ProtectedRoute><ProdutosCatalogo /></ProtectedRoute>} />
          <Route path="/campaigns/new" element={<ProtectedRoute><CampaignForm /></ProtectedRoute>} />
          <Route path="/campaigns/edit/:id" element={<ProtectedRoute><CampaignForm /></ProtectedRoute>} />
          <Route path="/campaigns/:id" element={<ProtectedRoute><CampaignDetails /></ProtectedRoute>} />
          <Route path="/templates" element={<ProtectedRoute><Templates /></ProtectedRoute>} />
          <Route path="/instagram-posts" element={<ProtectedRoute><InstagramPosts /></ProtectedRoute>} />
          <Route path="/planos" element={<ProtectedRoute><Planos /></ProtectedRoute>} />
          <Route path="/users" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin', 'gerente']}><Users /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/messages" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
          <Route path="/sessions" element={<ProtectedRoute><Sessions /></ProtectedRoute>} />
          <Route path="/whatsapp-groups" element={<ProtectedRoute><WhatsappGroups /></ProtectedRoute>} />
          <Route path="/cobertura" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <Cobertura />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/cobertura/segmento/:segmentoId" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente', 'operador', 'usuario']}>
                <CoberturaSegmento />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          <Route path="/metas" element={
            <ProtectedRoute>
              <ProtectedByLevel niveisPermitidos={['admin', 'gerente']}>
                <Metas />
              </ProtectedByLevel>
            </ProtectedRoute>
          } />
          {/* Admin */}
          <Route path="/admin" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminPanel /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminUsers /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/clients" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminClients /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/clients/:id" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><ClientDetails /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/management" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminManagement /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/plans" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminPlans /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/vendedores" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminVendedores /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/vendedores/:id" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminVendedorDetalhe /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/leads" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminLeads /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/leads-contato" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminLeadsContato /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/z-api" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminZApiInstances /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/cobranca" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminCobranca /></ProtectedByLevel></ProtectedRoute>} />
          <Route path="/admin/wallet" element={<ProtectedRoute><ProtectedByLevel niveisPermitidos={['admin']}><AdminWallet /></ProtectedByLevel></ProtectedRoute>} />
          {/* IA por cliente embutida em ClientDetails */}
          <Route path="*" element={<NotFound />} />
        </Routes>
          <ToastContainer position="top-right" />
        </div>
        </Router>
          </ToastProvider>
          </CadastroProvider>
        </InstancesProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;